import {
  handleCatchErrors,
  responseDataFormat,
} from "../../../middlewares/resolveRequests";
import {
  addCommunityData,
  assignCommunityMembers,
  deleteCommunityData,
  editCommunityData,
  getCommunitiesData,
  getCommunityData,
  getCommunityMembers,
} from "../../../services/admin/comunityCRUD";

export const getCommunities = async (pageNumber = 1, pageSize = 10, token) => {
  let response;
  try {
    response = await getCommunitiesData(pageNumber, pageSize, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const addCommunity = async (body, token) => {
  let response;
  try {
    response = await addCommunityData(body, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};
export const deleteCommunity = async (id, token) => {
  let response;
  try {
    response = await deleteCommunityData(id, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};
export const getCommunity = async (id, token) => {
  let response;
  try {
    response = await getCommunityData(id, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};
export const editCommunity = async (body, token) => {
  let response;
  try {
    response = await editCommunityData(body, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};
export const communityMembers = async (body, token) => {
  let response;
  try {
    response = await getCommunityMembers(body, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const setCommunityMembers = async (body, token) => {
  let response;
  try {
    response = await assignCommunityMembers(body, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};
